"use client";

import RequiredLoginDialog from "@/components/custom/common/required-login-dialog";
import { CustomIcon } from "@/components/custom/icons/custom-icon";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  SheetHeader,
  SheetTitle
} from "@/components/ui/sheet";
import { cn, isEmptyObject } from "@/lib/utils";
import { useUser } from "@/stores/user";
import { useState } from "react";
import MediaListView from "../../components/media-list/MediaListView";
import CampaignDialog from "./CampaignDialog";
import { useBookmarkStore } from "@/stores/bookmarkStore";
import { useTypedTranslations } from "@/i18n/typed";


export default function MediaLisAdvertiserRole(
) {
  const t = useTypedTranslations("mediaOnMap");
  const dataListFilter = [{ name: t('sort.byTraffic'), code: "KR" }];
  const {
    setFilterBookmarkedOnly,
    filterBookmarkedOnly,
  } = useBookmarkStore();

  const [shouldLoginModal, setShouldLoginModal] = useState(false);
  const { userInfo } = useUser();

  const handleFilteredBookmarked = () => {
    if (isEmptyObject(userInfo?.user)) {
      setShouldLoginModal(true);
      return;
    }
    setFilterBookmarkedOnly?.(!filterBookmarkedOnly);
  };

  return (
    <>
      <>
        <SheetHeader className="p-2.5 border-b">
          <SheetTitle className="py-[3px]">
            <div className="flex w-full items-center justify-between">
              <Button
                size="sm"
                appearance="outline"
                variant={"secondary"}
                onClick={handleFilteredBookmarked}
                className={cn(
                  "group transition-all hover:bg-transparent w-8.5 h-8.5 p-0",
                  filterBookmarkedOnly && "hover:bg-primary-200"
                )}
              >
                <CustomIcon
                  name="Bookmark"
                  className={cn(
                    "group-hover:text-primary h-4.5 w-3.5",
                    filterBookmarkedOnly && "text-primary"
                  )}
                />
              </Button>
              <Select>
                <SelectTrigger size="sm" className="w-[160px] !h-[35px] text-sm font-medium text-gray-500">
                  <SelectValue placeholder={t("sort.placeholder")} />
                </SelectTrigger>
                <SelectContent>
                  {dataListFilter.map((p) => (
                    <SelectItem key={`${p.code}`} value={`${p.code}`}>
                      {p.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </SheetTitle>
        </SheetHeader>
        <MediaListView onRequireLogin={handleFilteredBookmarked} />
        <CampaignDialog />
      </>
      {shouldLoginModal && (
        <RequiredLoginDialog
          isOpen={shouldLoginModal}
          onClose={() => setShouldLoginModal(false)}
        />
      )}
    </>
  );
}
